import constants from '../../settings/constants';
import storage from '../../services/history/storage';
// @ts-ignore // No types found
import { UrlUtility } from '@ikea-aoa/ikea-shared-utils';
import { Navigation } from './navigationTypes';

const {
  SESSION_STORAGE: { LANGUAGE_PICKER_ACTIVE_VIEW_KEY },
  VIEW_NAMES,
  INITIAL_VIEW,
} = constants;

export const getInitialView = () => {
  const initialView = UrlUtility.getHashQuery()[INITIAL_VIEW];
  const storageItem = storage.session.getItem(LANGUAGE_PICKER_ACTIVE_VIEW_KEY);

  if (!initialView) return VIEW_NAMES.SCENE;
  if (storageItem) return storageItem;
  if (!VIEW_NAMES.hasOwnProperty(initialView.toUpperCase()))
    throw new Error(`View '${initialView}' does not exist.`);

  return initialView.toUpperCase();
};

const defaultState: Navigation = {
  currentView: getInitialView(),
  views: Object.keys(VIEW_NAMES),
  history: [],
};

export default defaultState;
